var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail',{attrs:{"onManager":_vm.onManager,"data":_vm.data,"base-info":_vm.baseInfo,"extra-info":_vm.extraInfo,"hidden-keys":_vm.detailHiddenKeys,"status-module":"llmSku","resource":"llm_skus"}})
}
var staticRenderFns = []

export { render, staticRenderFns }